module.exports = __webpack_public_path__ + "img/serviroutes.47397f57.svg";